module.exports = __webpack_public_path__ + "img/20170319-2.bafa9870.jpeg";